import * as yup from "yup";
import type { Asserts } from "yup";

import { DeliveryMethod } from "../constants";

// Response from /offers validation

const offerSchema = yup.object({
  serviceType: yup.string().oneOf(Object.values(DeliveryMethod)).required(),
  priceGroupId: yup.string().required(),
  price: yup.number().required(),
  originalPrice: yup.number().nullable().optional(),
  notification: yup.string().nullable().optional(),
  serviceDuration: yup.string().nullable().optional(),
});

const couponSchema = yup.object({
  code: yup.string().nullable(),
  isValid: yup.bool().required(),
  blocked: yup.bool().optional(),
  isLimitedByUser: yup.bool().optional(),
});

const offersSchema = yup.object().shape({
  offers: yup.array().of(offerSchema),
  coupon: couponSchema.nullable(),
});

export type TOffersResponse = Asserts<typeof offersSchema>;

const validateOffersResponse = (response: any): TOffersResponse => offersSchema.validateSync(response);

export default validateOffersResponse;
